angular.module('impactx.disposition').controller('DispositionDoneDialogCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'dispositionId',
    DispositionDoneDialogCtrl]);

function DispositionDoneDialogCtrl($scope, dataGen, $mdDialog, dispositionId)
{
    dataGen.getData($scope, {dispositionId: dispositionId},"/disposition/dispositiondoneitem");
    $scope.hide = function ()
    {
        $mdDialog.hide();
    };
    $scope.cancel = function ()
    {
        $mdDialog.cancel();
    };
    $scope.answer = function (answer)
    {
        $mdDialog.hide(answer);
    };
}